module.exports = __webpack_public_path__ + "assets/ea2ac91836c1a4ae0967fad9c2dc7760.png";